import React, { useState, useEffect } from 'react';
import { apiService } from '../services/api';
import '../styles/common.css';

interface SmsMessagesDialogProps {
  apiKey: string;
  customerName: string;
  onClose: () => void;
}

export const SmsMessagesDialog: React.FC<SmsMessagesDialogProps> = ({ apiKey, customerName, onClose }) => {
  const [jsonResponse, setJsonResponse] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  
  useEffect(() => {
    // Fetch messages when component mounts
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    setIsLoading(true);
    setError(null);
    
    try {
      const result = await apiService.fetchMessages(apiKey);
      setJsonResponse(result);
    } catch (err) {
      console.error('Error fetching messages:', err);
      setError(err instanceof Error ? err.message : 'Failed to fetch messages');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="popup-overlay">
      <div className="popup-content sms-dialog">
        <div className="popup-header">
          <h2>SMS Messages - {customerName}</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="popup-body">
          {isLoading && (
            <div className="loading">Loading messages...</div>
          )}
          
          {error && (
            <div className="error-message">{error}</div>
          )}
          
          {jsonResponse && !isLoading && !error && (
            <div className="json-container">
              <pre className="json-content">
                {JSON.stringify(jsonResponse, null, 2)}
              </pre>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}; 